import { useTranslation } from 'react-i18next';
import { COOKIE_INVENTORY } from '../consent/consent-storage';
import type { ConsentCategory } from '../consent/types';

interface CookieTableProps {
  category?: ConsentCategory;
}

export function CookieTable({ category }: CookieTableProps) {
  const { t } = useTranslation();
  const categories: ConsentCategory[] = category
    ? [category]
    : ['necessary', 'functional', 'analytics', 'marketing'];

  return (
    <div className="space-y-4">
      {categories.map((cat) => {
        const items = COOKIE_INVENTORY[cat];
        return (
          <div key={cat}>
            <h3 className="text-sm font-semibold mb-2">{t(`cookies.categories.${cat}.title`)}</h3>
            {items.length === 0 ? (
              <p className="text-xs text-zinc-500 italic">{t('cookies.table.empty')}</p>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full text-xs border border-zinc-200 dark:border-zinc-800 rounded">
                  <thead className="bg-zinc-50 dark:bg-zinc-900/50">
                    <tr>
                      <th className="text-left p-2 font-medium">{t('cookies.table.name')}</th>
                      <th className="text-left p-2 font-medium">{t('cookies.table.purpose')}</th>
                      <th className="text-left p-2 font-medium">{t('cookies.table.duration')}</th>
                      <th className="text-left p-2 font-medium">{t('cookies.table.type')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item) => (
                      <tr key={item.name} className="border-t border-zinc-200 dark:border-zinc-800">
                        <td className="p-2 font-mono">{item.name}</td>
                        <td className="p-2 text-zinc-600 dark:text-zinc-400">{item.purpose}</td>
                        <td className="p-2 text-zinc-600 dark:text-zinc-400">{item.duration}</td>
                        <td className="p-2 text-zinc-600 dark:text-zinc-400">
                          {t(`cookies.table.types.${item.type}`)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
